<template>
  <flow-block-container
    @remove="$emit('remove')"
    @change-time="onChangeTime"
    @lock-time="onLockTime"
    @drag-time="onDragTime"
    @drag-time-active="onDragTimeActive"
    :show-connection="showConnection"
    :draggablesListVirtualOffsets="draggablesListVirtualOffsets"
    :dragTimeActive="dragTimeActive"
    :item="value">
    <div class="flow-tasklist" ref="flow_block">
      <!--
        {{ value.sortidx }}
        <div v-if="drag_active">
        drag_target_status_ok: {{ drag_target_status_ok }} <br />
        virtualOffsetCurrentSession: {{ virtualOffsetCurrentSession }}
      </div>-->
      <!--drag_active: {{ drag_active }}
      -->
      <!--idx:{{ idx }}<br />-->
      <div class="d-flex">
        <div v-if="imageSource" class="dayplanner-flow-item-image" :style="imageStyle">
          <!-- <div style="width: 45px; height: 45px"></div> -->
        </div>
        <div v-else>
          <EditableIcon v-model="item.icon" :is-editable="isEditable"/>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%">
          <div class="small-caps-goal-title">
            {{goal_meta.name}} &mdash;
          </div>
          <div class="flow-tasklist-headline">
            <span @click="onGoToCommitment" style="cursor: pointer">{{ item.title }}</span>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div>
              <span
                @mousedown="onBgDragMouseDown('to', $event)"
                style="cursor: ns-resize;">
                {{ sessionLength + virtualOffsetCurrentSession.duration | hoursMinutes }}
              </span>
              <!--<span  v-if="!show_reduced_dayplan"
                @click.prevent.stop="onLockTime({ selection: 'duration', value: !value.fixedDuration })"
                :class="{
                    'flow-time-btn': true,
                    'flow-time-unlockbtn': value.fixedDuration,
                    'flow-time-lockbtn': !value.fixedDuration,
                  }"
                :title="value.fixedDuration ? 'Unlock duration' : 'lock duration'"
              />-->
              <span
                v-if="dragTimeActive"
              >{{ virtualOffsetCurrentSession.duration > 0 ? '+' : '' }} {{ virtualOffsetCurrentSession.duration|hoursMinutes }}</span>
            </div>
            <template v-if="!show_reduced_dayplan">
              <div
                v-if="sessionBuffer !== sessionLength"
                v-tooltip="{ content: 'Click to set buffer to 0' }"
                :class="{
                  'clickable': true,
                  'flow-tasklist__buffer': true,
                  'flow-tasklist__buffer--negative': (sessionBuffer + this.virtualOffsetCurrentSession.duration) < 0,
                }"
                @click="onBufferClick"
                @mouseover="onBufferMouseover"
                @mouseout="onBufferMouseleave">
                <span v-if="bufferMouseoverActive">Buffer: {{ sessionBuffer  | hoursMinutes }}</span>
                <span v-else>Buffer: {{ sessionBuffer + this.virtualOffsetCurrentSession.duration | hoursMinutes }}</span>
              </div>
              <div v-else>
                <!-- don't show mouseover options if no tasks in session -->
                <span v-if="bufferMouseoverActive">Buffer: {{ sessionBuffer  | hoursMinutes }}</span>
                <span v-else>Buffer: {{ sessionBuffer + this.virtualOffsetCurrentSession.duration | hoursMinutes }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="commitment.$ready" class="mt-2">
        <kanban-list
          style="margin: 0 auto;"
          :show-header="false"
          :lane="commitment"
          :goal-id="goalId"
          :loading="tasks_loading"
          :data-element-id="item.$id"
          :data-goal-id="goalId"
          :filter-by-label="null"
          :show-finished="true"
          :show-archived="false"
          :show-prop-task-height="false"
          :search-string="null"
          :finish-dates="null"
          :sessionFrom="item.from"
          :sessionTo="item.to"
          :tasksInSession="item.tasks"
          :isDayplan="true"
          :sessionId="item.sessionId"
          :show-reduced-dayplan="show_reduced_dayplan"
          @drag-start="onDragStart"
          @drag-end="onDragEnd"
        />
      </div>
    </div>
    <pre class="mini-pre" v-if="SHOW_DEBUG && false">{{item.tasks}}</pre>
  </flow-block-container>
</template>

<script>
import { mapGetters } from "vuex";
import FlowBlockContainer from "./FlowBlockContainer";
import EditableIcon from "@/components/RoutineCreatorPage/Elements/EditableIcon";
import KanbanList from "@/components/GoalPage/Elements/KanbanList";
import SessionManagementMixin from "@/components/Mixins/SessionManagement"

//import { StringDecoder } from 'string_decoder';

// import DurationQuickSettings from "@/components/Elements/DurationQuickSettings";
//import clonedeep from "lodash.clonedeep";
// import SessionsEffort from "@/components/Sessions/SessionsEffort"

// TODO: Session oder TaskList anzeigen

export default {
  mixins: [SessionManagementMixin],
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true },
    optimizer_sessions_today: { // TODO: Vuex?
      type: Array,
    },
    tasks: {
      type: Array,
    },
    draggablesListVirtualOffsets: { // TODO: vuex?
      type: Object,
    },
    dragTimeActive: { // TODO: vuex?
      type: Boolean,
    },
    idx: {
      type: Number
    }
  },
  data: () => ({
    item: {},
    tasks_loading: true,
    timeFrom: null,
    timeTo: null,
    bufferMouseoverActive: false
  }),
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // TODO !!
    // TODO: Only load relevant tasks instead of entire kanban (with deleted and done)
    this.$models.task.subscribe_to_goal_tasks(this.goalId).then(() => {
      this.tasks_loading = false;
    });
  },
  computed: {
    ...mapGetters("dayplanner", [
      "show_reduced_dayplan",
      "drag_target_status_ok",
      "drag_item",
      'drag_item_placement',
      'drag_time_active',
      'dayplan_virtual_offsets'
    ]),
    commitmentId() {
      return this.value.config.commitmentId;
    },
    goalId() {
      return this.value.config.goalId;
    },
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },
    commitment() {
      return this.$models.commitment.with({ goalId: this.goalId }).subscribeNode(this.commitmentId);
    },
    imageStyle() {
      return {
        backgroundImage: "url(" + this.imageSource + ")",
        borderColor: this.tscColor, //this.session.color
      };
    },
    imageSource() {
      if (this.commitment.$ready) {
        if (this.commitment.picture) {
          return this.commitment.picture;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    virtualOffsetCurrentSession() {
      if (this.dayplan_virtual_offsets && this.dayplan_virtual_offsets[ this.item.sessionId ]) {
        return this.dayplan_virtual_offsets[ this.item.sessionId ]
      } else {
        return {
          from: 0,
          to: 0,
          duration: 0
        }
      }
    },
    sessionLength: {
      get() {
        return this.value.to - this.value.from;
      },
      set(duration) {
        console.log("blocked set");
        // this.value.to = this.value.from + duration
      },
    },

    sessionBuffer() {
      let taskDuration = 0;
      (this.item.tasks || []).forEach(task => {
        //console.log('sessionBuffer', task)
        taskDuration += task.duration
      })
      return this.sessionLength - taskDuration
    },

    drag_active() {
      if (this.drag_item && this.drag_item.sessionId && this.drag_item.sessionId === this.item.sessionId ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    onBgDragMove(e) {
      // TODO: Limit to start time + 5 min
      this.y_drag_offset = e.clientY - this.y_drag_offset_init;
      const f = 0.2; // Scale factor
      const steps = 5 * 60 // 5 Minute steps
      let offset = steps * f * this.y_drag_offset;

      this.onDragTime({ selection: this.y_drag_active, offset: offset })
      // Snap to grid: this.y_drag_offset = Math.round( this.y_drag_offset / 10 ) * 10;
    },
    onBgDragMouseDown(source, $event) {
      console.log('onBgDragMouseDown', source)
      this.timeFrom = this.item.from
      this.timeTo = this.item.to + this.virtualOffsetCurrentSession.duration
      $event.preventDefault();
      this.y_drag_offset_init = $event.clientY + 0;
      this.y_drag_active = source;
      window.addEventListener('mouseup', this.onBgDragMouseUp, false);
      window.addEventListener('pointerup', this.onBgDragMouseUp, false);
      window.addEventListener('mousemove', this.onBgDragMove, true);

      let rect = this.$refs.flow_block.getClientRects();
      this.y_drag_box_height = rect[0].height;
      document.body.style.cursor = 'ns-resize';
      this.onDragTimeActive({ value: true })

    },
    onBgDragMouseUp(source, $event) {
      window.removeEventListener('mouseup', this.onBgDragMouseUp, false);
      window.removeEventListener('pointerup', this.onBgDragMouseUp, false);
      window.removeEventListener('mousemove', this.onBgDragMove, true);
      console.log(this.timeFrom , this.item.from, this.timeTo, this.item.to)
      if (this.timeFrom !== this.item.from || this.timeTo !== this.item.to) {
        console.log('change the time!!')
        this.$emit('change-time', { selection: 'time', timeFrom: this.timeFrom, timeTo: this.timeTo })
      }
      this.y_drag_active = false;
      this.y_drag_offset_init = 0;
      // this.y_drag_offset = 0;
      document.body.style.cursor = 'default'
      this.onDragTimeEnd()
      this.onDragTimeActive({ value: false })
    },

    // TODO: move 1 level up or mixin
    onQuickSetDurationTask(value) {
      console.log("onQuickSetDurationTask", value);
      // this.item.session.sessionLength = duration;
      /*
      this.sessionLength = duration;
      this.$emit( 'input', this.item );
      */
      this.$emit("change-time", { selection: "duration", value }); // TODO
    },
    onChangeTime({ selection, timeTo, timeFrom }) {
      // console.log("onChangeTime", selection, value);
      this.$emit("change-time", { selection, timeTo, timeFrom });
    },
    onDragTime({ selection, offset }) {
      // console.log("onChangeTime", selection, value);
      this.timeFrom = this.item.from
      this.timeTo = this.item.to + this.virtualOffsetCurrentSession.duration
      this.$emit("drag-time", { selection, offset });
    },

    onBufferClick() {
      this.$emit("change-time", { selection: 'to', timeFrom: this.item.from, timeTo: Math.max(this.item.from + 5 * 60, this.item.to - this.sessionBuffer) });
    },

    onBufferMouseover() {
      if (!this.drag_time_active) {
        this.bufferMouseoverActive = true
        this.$emit("drag-time-active", { value: true });
        this.$emit("drag-time", { selection: 'to', offset: -this.sessionBuffer });
      }

    },
    onBufferMouseleave() {
      if (this.bufferMouseoverActive) {
        this.bufferMouseoverActive = false
        this.$emit("drag-time-active", { value: false });
      }
    },

    onDragTimeActive({ value }) {
      console.log("onDragTimeActive flowTasklist", value);
      this.$emit("drag-time-active", { value });
    },
    onLockTime({ selection, value }) {
      // console.log("onLockTime", selection, value);
      this.$emit("lock-time", { selection, value });
    },
    onGoToCommitment() {
      this.$router.push("/goal/" + this.goalId + "/kanban");
    },
    onDragStart(item) {
      console.log('FlowTasklist onDragStart', item)
      this.$emit('drag-task-start', item)
    },
    onDragEnd(destination) {
      console.log('FlowTasklist onDragEnd', destination)
      this.$emit('drag-task-end', destination)
    },
  },
  components: {
    EditableIcon,
    FlowBlockContainer,
    //DurationQuickSettings,
    // SessionsEffort,
    KanbanList,
  },
};
</script>

<style>
.dayplanner-flow-item-image {
  width: 50px;
  height: 50px;
  cursor: pointer;
  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-size: cover;
  flex: 0 0 50px;
  margin-right: 5px;
  /*margin-left: 5px;*/
  border-radius: 5px;
}
/* .dayplanner-flow-item-image img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
} */
.flow-tasklist .lane {
  /* display: flex; */
  /* justify-content: center; */
  padding-top: 0;
  /*padding-bottom: 0.2em;*/
  /* margin: 0 auto; */

  width: auto;
  padding-left: 0;
  padding-right: 0;
}
.flow-tasklist .list .list-inner {
  border: none;
  /*border-top: 1px solid #cfcfcf*/
  max-height: unset;
  overflow: unset;
  list-style: none;
  position: relative;
}
.flow-tasklist-headline { /* TODO: Dublicate css, see flow sequence.vue */
  font-weight: bold;
  font-size: 12pt;
  line-height: 1em;
  width: 100%;
  white-space: normal;
  text-overflow: ellipsis;
  -o-text-overflow: hidden;
  display: flex;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: left;
}
.flow-tasklist-headline:hover {
  text-decoration: underline;
  cursor: pointer;
}
.flow-tasklist .list footer {
  border: none;
}
.flow-tasklist__buffer--negative {
  color: red;
}
</style>
